var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplosionNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#FFF2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3327 14.6667L22.1947 13.8047C22.3442 13.6552 22.4627 13.4778 22.5436 13.2825C22.6244 13.0873 22.6661 12.878 22.6661 12.6667C22.6661 12.4899 22.7363 12.3203 22.8613 12.1953C22.9863 12.0702 23.1559 12 23.3327 12H23.9994M14.6661 18.6667C14.6661 18.1362 14.8768 17.6275 15.2518 17.2525C15.6269 16.8774 16.1356 16.6667 16.6661 16.6667M22.4327 15.7667C22.5071 15.841 22.5661 15.9292 22.6064 16.0263C22.6466 16.1234 22.6674 16.2275 22.6674 16.3327C22.6674 16.4378 22.6466 16.5419 22.6064 16.639C22.5661 16.7361 22.5071 16.8244 22.4327 16.8987L21.7847 17.5467C22.1083 18.6134 22.0661 19.7576 21.665 20.7976C21.2638 21.8375 20.5266 22.7137 19.5705 23.2867C18.6144 23.8598 17.4942 24.0969 16.3879 23.9604C15.2816 23.824 14.2527 23.3218 13.4645 22.5336C12.6763 21.7454 12.1741 20.7164 12.0376 19.6101C11.9012 18.5038 12.1383 17.3837 12.7114 16.4276C13.2844 15.4715 14.1605 14.7343 15.2005 14.3331C16.2405 13.9319 17.3847 13.8898 18.4514 14.2133L19.0994 13.5653C19.1737 13.491 19.2619 13.4319 19.359 13.3917C19.4562 13.3514 19.5603 13.3307 19.6654 13.3307C19.7705 13.3307 19.8746 13.3514 19.9717 13.3917C20.0689 13.4319 20.1571 13.491 20.2314 13.5653L22.4327 15.7667Z",
    stroke: "#A10505",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplosionNewIcon);
export default __webpack_public_path__ + "static/media/ExplosionNewIcon.61ffc85b2db79da4be8ab0b1bcb58c00.svg";
export { ForwardRef as ReactComponent };